import styled from "styled-components";

export const ContainerModalDropdown = styled.div<{isMobile: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${(props) => props.isMobile ? "10px" : ""};
  width: ${(props) => props.isMobile ? "100%" : "650px"};
`;

export const DivisorModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 5px;
`;

export const IconDel = styled.img<{isMobile: boolean}>`
height: ${(props) => (props.isMobile ? "40px" : "30px")};
margin-right: 10px;
cursor: pointer;

`;